import { forwardRef, SyntheticEvent } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps, AlertColor } from "@mui/material/Alert";

export type NotificationType = {
  type: AlertColor;
  message: string;
};

interface NotificationProps {
  notification: NotificationType;
  setNotification: (notification: NotificationType) => void;
  autoHideDuration?: number | null;
}

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Notification({
  notification,
  setNotification,
  autoHideDuration = 6000,
}: NotificationProps) {
  // An error is the one message the clinician has to act on, so it stays until
  // dismissed however short a duration the caller asked for.
  const duration =
    notification.type === "error" ? null : autoHideDuration ?? null;

  const handleClose = (event?: SyntheticEvent | Event, reason?: string) => {
    if (reason === "clickaway") {
      return;
    }
    setNotification({ ...notification, message: "" });
  };

  return (
    <Snackbar
      open={notification.message !== ""}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={notification.type}
        sx={{ width: "100%" }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
}
